import React from 'react';
import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

import { NumberFormat } from '@ecp/common/src/utils/utils';
import moTheme from '@ecp/common/src/style/theme/mo';
import { FlexBox, FlexBoxSpaceBetween } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';

import { useDisplayPrice } from '@mo-hooks/price/DisplayPriceHook';
import useSiteInfo from '@mo-hooks/common/useSiteInfo';

const GoodCtaButtonOptionTotalPrice = ({ totalPrice, totalFormattedPrice }) => {
  const theme = useTheme();
  const { priceFormat } = useSiteInfo();
  const internalTotalPrice = useDisplayPrice(NumberFormat(totalPrice), NumberFormat(totalFormattedPrice));

  return (
    <Wrapper>
      <TextBox size={moTheme.font.size.$14} weight={moTheme.font.weight.medium}>
        총 금액
      </TextBox>
      <FlexBox>
        <TextBox size={moTheme.font.size.$20} weight={moTheme.font.weight.bold} color={theme.color.primary}>
          {internalTotalPrice}
        </TextBox>
        <TextBox size={moTheme.font.size.$12} weight={moTheme.font.weight.demiLight} color={theme.color.primary}>
          {priceFormat}
        </TextBox>
      </FlexBox>
    </Wrapper>
  );
};

const Wrapper = styled(FlexBoxSpaceBetween)`
  width: 100%;
  padding-bottom: 14px;
`;

export default GoodCtaButtonOptionTotalPrice;

GoodCtaButtonOptionTotalPrice.propTypes = {
  totalPrice: PropTypes.number,
  totalFormattedPrice: PropTypes.number,
};
